import Core from "Core";

export class LicensesInUseStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/licenses-in-use.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }

  fetchByCustomerId(customerId) {
    this.fetch(`?customerId=${customerId}`);
  }

  fetchByLicenseId(licenseId) {
    this.fetch(`?licenseId=${licenseId}`);
  }

  findByLicenseId(licenseId) {
    let licensesInUseList = this.filter(l => l.LicenseId === licenseId);
    return licensesInUseList;
  }

  findByOffline() {
    const offlineLicensesInUseList = this.filter(l => l.Offline === 1);
    return offlineLicensesInUseList;
  }

  findByOfflineAndUserId(userId) {
    const offlineLicensesInUseList = this.filter(
      l => l.Offline === 1 && l.UserId === userId
    );
    return offlineLicensesInUseList;
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/LicensesInUseStore.js